import { Record } from 'immutable';
import { format, parseISO } from 'date-fns';
import { jobHelpers } from '@saucelabs/sl-util-helpers';

export const MetricsRecord = new Record({
  name: '',
  title: '',
  value: null,
  previousValue: null,
  labelClassName: '',
});

const TestCasesClass = new Record({
  name: null,
  total_runs: null,
  avg_duration: null,
  pass_rate: null,
  statuses: {
    passed: 0,
    errored: 0,
    complete: 0,
    failed: 0,
  },
});

export class TestCaseRecord extends TestCasesClass {
  getDuration() {
    return jobHelpers.getDuration(this.avg_duration);
  }

  getPassRatePercentage() {
    return `${this.pass_rate.toFixed(1)}%`;
  }
}

const TestRecordClass = new Record({
  id: null,
  consolidated_status: null,
  creation_time: null,
  duration_in_progress_sec: null,
  os_normalized: null,
  browser_normalized: null,
});

export class TestRecord extends TestRecordClass {
  formatCreationTime() {
    return format(parseISO(this.creation_time), 'yyyy-MM-dd HH:MM:ss');
  }
}

export const FailureTestRecord = new Record({
  id: null,
  name: null,
  testCount: null,
  rootCauseUrl: null,
  loading: true,
  rootCauses: [],
});
